import React from "react";
import { Link } from "react-router-dom";
import { ROUTES_CONFIG } from "src/constants/routesConfig";

const HomeButton: React.FC = () => {
  return (
    <Link to={ROUTES_CONFIG.home.path}>
      <button className="text-black border border-black bg-white text-sm font-normal py-1.5 px-0 transition-all duration-300 rounded-[32px] w-[200px] min-w-[50px] hover:cursor-pointer disabled:cursor-auto disabled:text-gray-300 text-center">
        Home
      </button>
    </Link>
  );
};

export { HomeButton };
